export enum ClientIdType {
  General = 1,
}
